import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { BasketOwner } from '../../interfaces/Basket/BasketOwner';
import { BasketOwnerFilter } from '../../interfaces/Basket/BasketOwnerFilter';
import { getBasketOwners } from '../../api/Basket';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { SearchBox } from '../../components/SearchBox/SearchBox';
import { BasketOwnersTable } from './BasketOwnersTable';
import { sendBasketReminderToUser } from '../../api/ReminderNotification';

export const BasketOwnersPage = () => {
  const [basketOwners, setBasketOwners] = useState<
    PaginatedResponse<BasketOwner>
  >({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState<BasketOwnerFilter>({
    search: '',
    pagination: { page: 0, pageSize: 10 },
  });
  const [loading, setLoading] = useState(false);
  const [loadingNotification, setLoadingNotification] = useState(false);

  const refreshBasketOwners = () => {
    setLoading(true);
    getBasketOwners(filter)
      .then((o) => setBasketOwners(o))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshBasketOwners();
  }, [filter]);

  const sendNotification = (basketOwner: BasketOwner) => {
    setLoadingNotification(true);
    sendBasketReminderToUser(basketOwner.userID)
      .then(() => {
        toast.success(
          `${basketOwner.email} adresine hatırlatma e-postası gönderildi`,
        );
        refreshBasketOwners();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoadingNotification(false));
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading || loadingNotification} />

      <Box sx={{ display: 'flex', flexDirection: 'row', mb: 1.5 }}>
        <Typography variant='h5'>Aktif Sepetli Kullanıcılar</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <SearchBox
          placeholder='Kullanıcı Ara'
          initialValue={filter.search ?? ''}
          onChange={(s) =>
            setFilter({
              ...filter,
              search: s,
              pagination: { ...filter.pagination, page: 0 },
            })
          }
        />
      </Box>

      <BasketOwnersTable
        basketOwners={basketOwners.data}
        totalCount={basketOwners.totalCount}
        pagination={filter.pagination}
        onPagination={(p) => setFilter({ ...filter, pagination: p })}
        onSendNotification={sendNotification}
      />
    </Box>
  );
};
